import React from 'react';
import { Card } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import styles from './KnowBefore.module.less';
import { trackButtonClick } from '../../../../lib/fpti';
import isAbsolutePath from '../../../../util/isAbsolutePath';

function KnowBefore({ knowBeforeCards }) {
  const navigate = useNavigate();

  const handleClick = (key, url) => {
    trackButtonClick(key, url);
    if (isAbsolutePath(url)) {
      if (url.includes('/studio')) {
        window.open(url, '_self', 'popup=false');
      } else {
        window.open(url, '_blank');
      }
    } else {
      navigate(url);
    }
  };

  return (
    <div>
      <p className={`${styles.card_section_title}`}>{knowBeforeCards.title}</p>
      {knowBeforeCards.cards.map((card, index) => (
        <div key={index} className={`${styles.card}`}>
          <Card onClick={() => handleClick(card.key, card.url)}>
            <div>
              <div className={`${styles.card_title}`}>{card.key}</div>
              <div className={`${styles.card_description}`}>{card.badge}</div>
              {card.text && (
                <div
                  className={`${styles.credentials_text}`}
                  dangerouslySetInnerHTML={{ __html: card.text }}
                />
              )}
            </div>
          </Card>
        </div>
      ))}
    </div>
  );
}

KnowBefore.propTypes = {
  knowBeforeCards: PropTypes.object.isRequired
};

export default KnowBefore;
